module.exports = __webpack_public_path__ + "static/media/turkey-flag.4f50a416.svg";